import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, message, Popconfirm } from 'antd';
import { Route, Switch } from "react-router-dom";

import List from '../../components/List';
import Create from './create';
import {
  createResource,
  deleteResource,
  deleteSpareInPurchaseInvoice,
  fetchResource,
  getResource,
  getResourceForDownload,
  saveResourceQuery,
  updateResource,
} from "../../appRedux/actions/PurchaseOrder";
import {
  fetchFilter,
  fetchRelationshipSearchData,
  fetchSubDocumentFilter,
  fetchSubElementFilter,
  getAllUOM,
  unmountPurchaseOrder
} from '../../appRedux/actions';
import {
  faviconDynamicFunction,
  getColumnSearchProps,
  getRenderForFieldByType,
  sanitizeFieldName
} from '../../util/methods'
import AccessControl from "../../components/AccessControl";
import * as _ from 'lodash';
import AssetPurchaseReport from "./asset-purchase-report";

export class PurchaseOrder extends Component {
  initialQueryState = {
    sort: {
      field: '',
      order: ''
    },
    pagination: {
      pageSize: 10,
      current: 1
    },
    filters: {},
  };

  state = {
    fields: {
      name: {
        value: '',
      },
      description: {
        value: ''
      }
    },
    query: this.initialQueryState,
    columns: [],
    visibleColumns: []
  };

  constructor(props) {
    super(props);
    props.saveResourceQuery(this.initialQueryState);
  }

  componentDidMount() {
    this.fetchList();
    this.props.fetchFilter(this.props.resourceName);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.filters._id && this.props.filters._id !== nextProps.filters._id) {
      const columns = Object.keys(nextProps.filters).filter((filter) => Boolean(nextProps.filters[filter].options && nextProps.filters[filter].options.column));
      const defaultCol = ['createdBy'];
      this.setState({
        visibleColumns: [...defaultCol, ...columns]
      }, () => {
        this.renderColumns(nextProps.filters, this.state.visibleColumns);
      })
      // this.setState({
      //   visibleColumns: columns
      // }, () => {
      //   this.renderColumns(nextProps.filters, this.state.visibleColumns);
      // })
    }
  }

  handleColumnChange = (value, array) => {
    const { filters } = this.props;
    this.renderColumns(filters, value);
  };

  handleFilter = (selectedKeys, confirm, data) => {
    const query = { ...this.props.query };
    query.filters[data.field] = JSON.stringify({
      value: selectedKeys,
      type: data.type,
      field: data.field
    });
    this.props.saveResourceQuery(query);
    confirm();
    // this.fetchList();
  };

  handleReset = (clearFilters, data) => {
    const query = { ...this.props.query };
    delete query.filters[data.field];
    this.props.saveResourceQuery(query);
    clearFilters();
    this.fetchList();
  };

  handleChange = (pagination, filters, sorter) => {
    const query = { ...this.props.query };
    query.pagination = { ...query.pagination, current: pagination.current };
    query.sort = sorter;

    this.props.saveResourceQuery(query);
    this.fetchList();
  };

  handleFormChange = (changedFields) => {
    this.setState(({ fields }) => ({
      fields: { ...fields, ...changedFields },
    }));
  };

  renderColumns = (filters, selectedColumns) => {
    filters = filters || this.props.filters;
    const columns = [];
    const { resourceName } = this.props;

    Object.keys(filters).forEach((item) => {

      if (item === '_id') {
        return;
      }

      if (selectedColumns.indexOf(item) === -1) {
        return;
      }

      // createdBy / lastUpdatedBy have dedicated columns below. Skip them here so the real
      // `createdBy` schema field does not also render a duplicate generic column.
      if (item === 'createdBy' || item === 'lastUpdatedBy') {
        return;
      }

      columns.push(
        {
          title: item === 'poNo' ? 'PI No' : item === 'grnDate' ? 'MGRN Date' : sanitizeFieldName(item),
          dataIndex: filters[item].field,
          sorter: true,
          render: (value) => getRenderForFieldByType(value, filters[item].type, item),
          ...getColumnSearchProps(filters[item], this.handleFilter, this.handleReset, resourceName)
        }
      )
    });
    if (selectedColumns.indexOf("totalAmount") >= 0) {
      columns.push({
        title: 'Total Amount',
        dataIndex: 'totalAmount',
        key: 'totalAmount',
        sorter: true,
        render: (value) => getRenderForFieldByType(value, 'Number'),
      }
      );
    }

    if (selectedColumns.indexOf('createdBy') >= 0) {
      columns.push({
        title: 'Created By',
        dataIndex: 'createdBy',
        key: 'createdBy',
        // sorter: true,
        // Real `createdBy` field populates to the User directly (value.name); keep the old
        // virtual shape (value.user.name) as a fallback for any legacy populated data.
        render: (value) => (value && (value.name || (value.user && value.user.name))) || '-'
      })
    }

    if (selectedColumns.indexOf('lastUpdatedBy') >= 0) {
      columns.push({
        title: 'Last Updated By',
        dataIndex: 'lastUpdatedBy',
        key: 'lastUpdatedBy',
        // sorter: true,
        render: (value) => value && value.user && value.user.name || '-'
      })
    }


    columns.push({
      title: 'Action',
      key: 'action',
      render: (record) => (
        <div>
          <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
            roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
              return <Button type="primary" size='small' onClick={() => this.view(record._id)}>View</Button>
            }} />
          <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
            roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
              return <Button type="primary" size='small' style={{ marginLeft: '8px' }} onClick={() => this.edit(record._id)}>Edit</Button>
            }} />

          <AccessControl resource={this.props.resourceName} permissionNeeded={'d'}
            roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
              return <Popconfirm
                title="Are you sure you want to delete this record?"
                onConfirm={() => {
                  this.deleteResource(record._id)
                }}
                onCancel={this.cancelDelete}
                okText="Yes"
                cancelText="No"
              >
                <Button style={{ marginLeft: '10px' }}
                  type="danger"
                  size='small'
                  disabled={record && record.type === 'Asset'}
                >Delete</Button>
              </Popconfirm>
            }} />

        </div>
      ),
    });

    this.setState({
      visibleColumns: selectedColumns,
      columns
    })
  };

  // clearAll = () => {
  //   this.props.saveResourceQuery(this.initialQueryState);
  //   this.fetchList();
  // };

  clearAll = () => {
    const clearQueryState = {
      sort: {
        field: '',
        order: ''
      },
      pagination: {
        pageSize: 10,
        current: 1
      },
      filters: {},
    };
    //this.props.saveResourceQuery(this.initialQueryState);
    this.props.saveResourceQuery(clearQueryState);
    this.fetchList();
  };

  fetchList = () => {
    this.props.getResource();
  };

  createResource = (values) => {
    this.props.createResource(values);
  };

  updateResource = (values, id) => {
    values.documents = values.documents || [];
    this.props.updateResource(values, id);
  };

  deleteResource = (id) => {
    this.props.deleteResource(id);
  };

  cancelDelete = () => {
    message.error('Cancelled')
  };

  create = () => {
    const { match } = this.props;
    this.props.history.push(`${match.url}/add`);
  };

  view = (id) => {
    const { match } = this.props;
    this.props.history.push(`${match.url}/view/${id}`);
  };

  edit = (id) => {
    const { match } = this.props;
    this.props.history.push(`${match.url}/edit/${id}`);
  };

  downloadToCSV = () => {
    const columns = [];
    this.state.columns.map(column => column.title !== "Action" && columns.push(_.camelCase(column.title)));
    this.props.getResourceForDownload(JSON.stringify(columns), this.props.filters, "PurchaseInvoice");
  }

  deleteSpareInPurchaseInvoice = (spareId, purchaseOrderID) => {
    this.props.deleteSpareInPurchaseInvoice(spareId, purchaseOrderID);
  }

  render() {
    const { match, data, resource, edit, fetchResource, loading, filters, modules, authUser, resourceName, searchData, fetchRelationshipSearchData, unmountPurchaseOrder, uomData } = this.props;
    // console.log('data : ', data)
    const { columns, visibleColumns } = this.state;
    faviconDynamicFunction(authUser);
    return (<div>
      <h2>{sanitizeFieldName('purchaseInvoice')}</h2>

      <Switch>
        <Route path={`${match.url}`} exact
          render={() => <List columns={columns}
            visibleColumn={visibleColumns}
            data={data}
            clearFilter={this.clearAll}
            filters={filters}
            handleChange={this.handleChange}
            columnChange={this.handleColumnChange}
            downloadToCSV={this.downloadToCSV}
            title={resourceName}
            size={'middle'}
            create={this.create}
            pagination={this.props.query.pagination}
            loading={loading}
            authUser={authUser}
          />
          } />
        <Route path={`${match.url}/add`}
          render={(props) => <Create data={{}}
            authUser={authUser}
            filters={filters}
            subDocumentFilters={this.props.subDocumentFilters}
            subElementFilters={this.props.subElementFilters}
            fetchSubElementFilter={this.props.fetchSubElementFilter}
            fetchEquipmentSubType={fetchRelationshipSearchData}
            searchData={searchData}
            getAllUOM={this.props.getAllUOM}
            uomData={uomData}
            modules={modules}
            title={'CREATE'}
            resource={resourceName}
            onChange={this.handleFormChange}
            onSubmit={this.createResource}
            loading={loading}
            unmountPurchaseOrder={unmountPurchaseOrder}
            {...props}
          />
          } />
        <Route path={`${match.url}/edit/:id`}
          render={(props) => <Create data={edit}
            authUser={authUser}
            filters={filters}
            modules={modules}
            subDocumentFilters={this.props.subDocumentFilters}
            subElementFilters={this.props.subElementFilters}
            fetchSubDocumentFilter={this.props.fetchSubDocumentFilter}
            fetchSubElementFilter={this.props.fetchSubElementFilter}
            fetchEquipmentSubType={fetchRelationshipSearchData}
            deleteSpareInPurchaseInvoice={this.deleteSpareInPurchaseInvoice}
            searchData={searchData}
            getAllUOM={this.props.getAllUOM}
            uomData={uomData}
            title={'EDIT'}
            resource={resourceName}
            fetch={fetchResource}
            onChange={this.handleFormChange}
            onSubmit={this.updateResource}
            loading={loading}
            unmountPurchaseOrder={unmountPurchaseOrder}
            {...props}
          />
          } />
        <Route path={`${match.url}/view/:id`}
          render={(props) => <Create data={edit}
            authUser={authUser}
            filters={filters}
            modules={modules}
            subDocumentFilters={this.props.subDocumentFilters}
            subElementFilters={this.props.subElementFilters}
            fetchSubDocumentFilter={this.props.fetchSubDocumentFilter}
            fetchSubElementFilter={this.props.fetchSubElementFilter}
            fetchEquipmentSubType={fetchRelationshipSearchData}
            deleteSpareInPurchaseInvoice={this.deleteSpareInPurchaseInvoice}
            searchData={searchData}
            getAllUOM={this.props.getAllUOM}
            uomData={uomData}
            title={'VIEW'}
            resource={resourceName}
            fetch={fetchResource}
            onChange={this.handleFormChange}
            onSubmit={this.updateResource}
            loading={loading}
            unmountPurchaseOrder={unmountPurchaseOrder}
            {...props}
          />
          } />

        <Route path={`${match.url}/asset-purchase-report`}
          render={() => <AssetPurchaseReport />} />
      </Switch>
    </div>)
  }
}

const mapStateToProps = ({ auth, purchaseOrder, commonData }) => {
  return {
    authUser: auth.authUser,
    total: purchaseOrder.total,
    data: purchaseOrder.resources,
    resource: purchaseOrder.resource,
    edit: purchaseOrder.edit,
    query: purchaseOrder.query,
    loading: commonData.loading,
    filters: commonData.filters,
    modules: commonData.modules,
    subDocumentFilters: commonData.subDocumentFilters,
    subElementFilters: commonData.subElementFilters,
    searchData: commonData.relationshipSearch,
    uomData: purchaseOrder.uomData,
  }
};

function mapDispatchToProps(dispatch) {
  return {
    getResource,
    getResourceForDownload,
    createResource,
    fetchResource,
    updateResource,
    deleteResource,
    saveResourceQuery,
    fetchFilter,
    fetchSubDocumentFilter,
    fetchSubElementFilter,
    fetchRelationshipSearchData,
    unmountPurchaseOrder,
    getAllUOM,
    deleteSpareInPurchaseInvoice,
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(PurchaseOrder);
